import React, { useEffect, useState } from 'react';
import { FiFilter } from 'react-icons/fi';
import { connect } from 'react-redux';
import { Button, CustomDropdown } from 'src/components/common';
import { People } from 'src/dataFactory/depositionFactory';

import { IAppState } from 'src/store';

const UploaderFilterButton: React.FC<Props> = ({ onChange, involvedPaties, defaultOption }) => {
  const SORTING_OPTIONS = [{ id: 'all', label: 'All', icon: 'ic_fax' }].concat(
    involvedPaties?.map(p => {
      return { id: p.id, label: `UPLOADED BY ${p.name}`, icon: 'ic_fax' };
    }) ?? [],
  );
  const [selectedParty, setSelectedParty] = useState(defaultOption);

  useEffect(() => {
    setSelectedParty(defaultOption);
  }, [defaultOption]);

  const handleSelectItem = (id: string) => () => {
    setSelectedParty(id);
    onChange && onChange(id);
  };

  const filteredOptions = SORTING_OPTIONS.map(option => ({
    ...option,
    onClick: handleSelectItem(option.id),
    isActive: option.id === selectedParty,
  }));

  const Label = () => {
    return (
      <Button id="sorting-button" variant="sorting" icon={<FiFilter />}>
        FILTER
      </Button>
    );
  };

  return <CustomDropdown xPosition="left" label={<Label />} items={filteredOptions} />;
};

export type SortingOption = {
  label: string;
  icon: React.ReactElement;
  filed: string;
  value: string;
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onChange?: (...args: any[]) => void;
    involvedPaties?: People[];
    defaultOption: string;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UploaderFilterButton);
